import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters(['gameSettings']),
    },
    methods: {
        checkGenderLimit(teamId) {
            if(this.gameSettings.enforceGenderLimit === '0') {
                return true;
            }
            // Hole das Team anhand der übergebenen `teamId`.
            const team = this.teams.find(t => t.id === teamId);
            if (!team) {
                console.error('Team nicht gefunden!');
                return;
            }

            // Überprüfe die ersten 5 Spieler des Teams.
            const firstFivePlayers = team.players.slice(0, 5);

            // Zähle die Anzahl der Spieler basierend auf ihrem Geschlecht.
            const maleCount = firstFivePlayers.filter(player => player.gender === 'm').length;
            const femaleCount = firstFivePlayers.filter(player => player.gender === 'f').length;
            // Überprüfe, ob das Verhältnis 2:3 eingehalten wird.
            if (!((maleCount === 2 && femaleCount === 3) || (maleCount === 3 && femaleCount === 2))) {
                alert(this.$t('teamSetup.GenderRatioIncorrect', {
                    team: team.name
                }));

                return false; // Verhältnis ist nicht korrekt.
            }

            return true; // Verhältnis ist korrekt.
        }
    }
}